import { getP } from 'redux-polyglot'
import api from '../libs/api'

/**
 * Actions for fetching recommendations from API
 */
export const FETCH_RECOMMENDATIONS_REQUEST = 'RECOMMENDATIONS/FETCH_RECOMMENDATIONS_REQUEST'
export const FETCH_RECOMMENDATIONS_SUCCESS = 'RECOMMENDATIONS/FETCH_RECOMMENDATIONS_SUCCESS'
export const FETCH_RECOMMENDATIONS_FAILURE = 'RECOMMENDATIONS/FETCH_RECOMMENDATIONS_FAILURE'

const fetchRecommendationsRequest = () => ({
  type: FETCH_RECOMMENDATIONS_REQUEST
})

const fetchRecommendationsSuccess = (recommendations, interval) => ({
  type: FETCH_RECOMMENDATIONS_SUCCESS,
  payload: {
    recommendations,
    interval
  }
})

const fetchRecommendationsFailure = error => ({
  type: FETCH_RECOMMENDATIONS_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true
})

export const loadRecommendations = () => (dispatch, getState) => {
  dispatch(fetchRecommendationsRequest())
  return api.getRecommendations()
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return dispatch(fetchRecommendationsSuccess(response.recommendations, response.rotation_interval))
        } else {
          return dispatch(fetchRecommendationsFailure(response.reason))
        }
      },
      () => dispatch(fetchRecommendationsFailure(getP(getState()).t("tv_home.error_retrieving_recommendations", { _: "An error occurred while retrieving recommendations" })))
    )
}

/**
 * Actions related to recommendation slideshow
 */
export const SLIDE_RECOMMENDATION = 'RECOMMENDATIONS/SLIDE_RECOMMENDATION'
export const slideRecommendation = () => ({
  type: SLIDE_RECOMMENDATION
})
